let languages=JSON.parse(localStorage.getItem('languages'));
const language = {
	shenqingshijian:languages=='zh'?'申请时间':'신청일',
	beizhu:languages=='zh'?'备注':'비고',
	cangku:languages=='zh'?'仓库':'창고',
	mujuanhao:languages=='zh'?'母卷号':'원코일번호',
	mujuanzhongliang:languages=='zh'?'母卷重量':'원코일중량',
	mujuanguige:languages=='zh'?'母卷规格':'원코일규격',
	pinzhong:languages=='zh'?'品种':'품명',
	paihao:languages=='zh'?'牌号':'재질',
	guige:languages=='zh'?'规格':'규격',
	kunbaohao:languages=='zh'?'捆包号':'제품번호',
	shouhuokehu:languages=='zh'?'收货客户':'업체',
	shengchanzhuangtai:languages=='zh'?'生产状态':'생산 상태',
	shenpizhuangtai:languages=='zh'?'审批状态':'승인 상태',
	rukuriqi:languages=='zh'?'入库日期':'입고일',
	jiaohuoqi:languages=='zh'?'交货期':'납기',
	shengchanjiaohuoqi:languages=='zh'?'生产交货期':'생산납기',
	chengpinkunbaohao:languages=='zh'?'成品捆包号':'제품번호',
	chengpinguige:languages=='zh'?'成品规格':'제품 규격',
	chengpinzhongliang:languages=='zh'?'成品重量':'제품중량',
	chengpinshuliang:languages=='zh'?'成品数量':'제품 수량',
	shenqingriqi:languages=='zh'?'申请日期':'신청일',
	heji:languages=='zh'?'合计':'합계',
	jiagongzhongliang:languages=='zh'?'加工重量':'가공 무게',//1
	shenqingzhuangtai:languages=='zh'?'申请状态':'신청상태',//1
	shenqingpicihao:languages=='zh'?'申请批次号':'신청번호',//1
	chaxunqingdianjiwo:languages=='zh'?'查询请点击我':'조회',//1
	mujuanpinzhong:languages=='zh'?'母卷品种':'원코일 품명',//1
	mujuankunbaohao:languages=='zh'?'母卷捆包号':'원코일번호',//1
	mujuanpaihao:languages=='zh'?'母卷牌号':'원코일 재질',
	zhongliang:languages=='zh'?'重量':'중량',//1
	caozuo:languages=='zh'?'操作':'작업',//1
	chengpin:languages=='zh'?'成品':'제품',//1
	juanjing:languages=='zh'?'卷径':'내경',
	yewuleixing:languages=='zh'?'业务类型':'업무유형',
	kuwei:languages=='zh'?'库位':'창고위치',
	neiwaiban:languages=='zh'?'内外板':'내외판',
	cunhuoxingzhi:languages=='zh'?'存货性质':'재고유형',
	jiesuanyonghu:languages=='zh'?'结算用户':'결산고객',
	jiesuanbizhong:languages=='zh'?'结算币种':'결산화폐',
	jiaohuofangshi:languages=='zh'?'交货方式':'납품방식',
	jiaohuodi:languages=='zh'?'交货地':'착지',
	chengyunshang:languages=='zh'?'承运商':'운송업체',
	chepaihao:languages=='zh'?'车牌号':'차량번호',
	yuanliao:languages=='zh'?'原料':'원소재',
	jiazaigengduo:languages=='zh'?'加载更多':'더 많은 내역 보기',
	jiazaiwanbi:languages=='zh'?'加载完毕':'완료',
	shouye:languages=='zh'?'首页':'메인화면',
	tihuoshenqing:languages=='zh'?'提货申请':'출하신청',
	gouwuche:languages=='zh'?'购物车':'장바구니',
	tihuojihua:languages=='zh'?'提货计划':'원코일출하계획',
	fanhui:languages=='zh'?'返回':'되돌아가기',
	chongzhi:languages=='zh'?'重置':'모두 삭제',
	chaxun:languages=='zh'?'查询':'조회',
	guanbi:languages=='zh'?'关闭':'닫기',
	tijiao:languages=='zh'?'提交':'제출',
	gong:languages=='zh'?'共':'총 ',
	tiao:languages=='zh'?'条':' 건',
	tiao2:languages=='zh'?'C':' C',
	hou:languages=='zh'?'厚':'두께',
	kuan:languages=='zh'?'宽':'폭',
	chang:languages=='zh'?'COIL':'길이',
	hejizongzhongliang:languages=='zh'?'合计总重量':'합계 중량',
	zaikukucunchaxun:languages=='zh'?'在库库存查询':'현재고 조회',
	shuliang:languages=='zh'?'数量':'수량',
	shanchuchenggong:languages=='zh'?'删除成功':'삭제 성공',
	qingshaodeng:languages=='zh'?'请稍等':'잠시만 기다려주세요',
	jiagongdingdanshenqingchakan:languages=='zh'?'加工订单申请查看':'가공신청 내역 조회',
	jiagongdingdanshenqing:languages=='zh'?'加工订单申请':'가공신청',
	daishenpi:languages=='zh'?'待审批':'승인 대기',
	shengchengdingdan:languages=='zh'?'生成订单':'주문 접수 완료',
	chexiaochenggong:languages=='zh'?'撤销成功':'취소 완료',
	bufenshenpi:languages=='zh'?'部分审批':'부분 승인',
	xitongshenpibutongguo:languages=='zh'?'系统审批不通过':'시스템 반려',
	yewuyuanshenpibutongguo:languages=='zh'?'业务员审批不通过':'승인 거절',
	yewuyuanshenpitongguo:languages=='zh'?'业务员审批通过':'승인 완료',
	shujuxiazai:languages=='zh'?'数据下载':'Download',
	tihuoshenqingchakan:languages=='zh'?'提货申请查看':'출하신청 내역 조회',
	yewuyuanshenpichenggong:languages=='zh'?'业务员审批成功':'승인 완료',
	tihuozhongliang:languages=='zh'?'提货重量':'출하중량',
	chukuzhuangtai:languages=='zh'?'出库状态':'출고상태',
	danjuhao:languages=='zh'?'单据号':'서류번호',
	shenhezhuangtai:languages=='zh'?'审核状态':'승인 상태',
	jiaohuoqujian:languages=='zh'?'交货区间':'납품 구간',
	weichuku:languages=='zh'?'未出库':'미출고',
	bufenchuku:languages=='zh'?'部分出库':'부분출고',
	yichuku:languages=='zh'?'已出库':'기출고',
	xiaoshoutidanchakan:languages=='zh'?'销售提单查看':'거래명세서 조회',
	tidanhao:languages=='zh'?'提单号':'송장번호',
	laiyuan:languages=='zh'?'来源':'소스',
	picihao:languages=='zh'?'批次号':'신청번호',
	zhuangtai:languages=='zh'?'状态':'상태',
	fahuodidian:languages=='zh'?'发货地点':'출하지점',
	chukuzhuangtai:languages=='zh'?'出库状态':'출고 상태',
	fahuoqishiriqi:languages=='zh'?'发货起始日期':'출하 시작일',
	fahuozhongliang:languages=='zh'?'发货重量':'출하중량',
	fahuoshuliang:languages=='zh'?'发货数量':'출하수량',
	zuofei:languages=='zh'?'作废':'폐기',
	luru:languages=='zh'?'录入':'입력',
	shenpitongguo:languages=='zh'?'审批通过':'승인완료',
	shenpituihui:languages=='zh'?'审批退回':'반려',
	bufenfahuo:languages=='zh'?'部分发货':'부분출하',
	quanbufahuo:languages=='zh'?'全部发货':'모두 출하',
	tidanjiesuanwancheng:languages=='zh'?'提单结算完成':'결산완료',
	chukushenqingjiesuanwancheng:languages=='zh'?'出库申请结算完成':'출고신청결산완료',
	bufenjiesuan:languages=='zh'?'部分结算':'부분결산',
	tidan:languages=='zh'?'提单':'송장',
	chukushenqing:languages=='zh'?'出库申请':'출하요청',
	danjuleixing:languages=='zh'?'单据类型':'서류유형',
	jiliangdanwei:languages=='zh'?'计量单位':'단위',
	yewuxingzhi:languages=='zh'?'业务性质':'유형',
	kunbaolaiyuanleixing:languages=='zh'?'捆包来源类型':'출처유형',
	biaoqianriqi:languages=='zh'?'标签日期':'원소재 생산일자',
	gangchangziyuanhao:languages=='zh'?'钢厂资源号':'계약번호',
	zhengshuhao:languages=='zh'?'证书号':'밀시트번호',
	shujuweikong:languages=='zh'?'数据为空':'데이터가 없습니다',
	yichukuchaxun:languages=='zh'?'已出库查询':'기출고내역 조회',
	chukushijian:languages=='zh'?'出库时间':'출고일',
	chukuleixing:languages=='zh'?'出库类型':'출고유형',
	pinming:languages=='zh'?'品名':'품명',
	chukuriqi:languages=='zh'?'出库日期':'출고일자',
	laiyuanleixing:languages=='zh'?'来源类型':'출고유형',
	kuweimingcheng:languages=='zh'?'库位名称':'출고위치',
	zhujiliangdanwei:languages=='zh'?'主计量单位':'단위',
	zhudanweishuliang:languages=='zh'?'主单位数量':'수량',
	chaxunchenggong:languages=='zh'?'查询成功':'완료',
	zhibaoshuchaxun:languages=='zh'?'质保书查询':'밀시트 조회',
	yuanliaojiagong:languages=='zh'?'原料加工':'밀시트 조회',
	gangchangziyuanhaoweikongbunengchakan:languages=='zh'?'钢厂资源号为空，不能查看数据':'계약번호가 존재하지 않습니다. 데이터를 조회할 수 없습니다',
	zhiliangshujuyufenxi:languages=='zh'?'质量数据与分析':'품질보증서 데이터 분석',
	jiaohuoqishiriqi:languages=='zh'?'交货起始日期':'납품 시작시간',
	jiaohuozhongzhiriqi:languages=='zh'?'交货起始日期':'납품 시작시간',
	chanpinpinming:languages=='zh'?'产品品名':'품명',
	hetonghao:languages=='zh'?'合同号':'계약번호',
	kehudingdanhao:languages=='zh'?'客户订单号':'주문번호',
	jiaohuoriqi:languages=='zh'?'交货日期':'납기일',
	luhao:languages=='zh'?'炉号':'HEAT NO.',
	zhangshu:languages=='zh'?'张数':'장수',
	biaojudaima:languages=='zh'?'标距代码':'GAUGE LENTH:',
	qufubi:languages=='zh'?'屈服比':'YS',
	kangla:languages=='zh'?'抗拉':'TS',
	shenchang:languages=='zh'?'伸长':'EL',
	qufu:languages=='zh'?'屈服':'Y.S.',
	wanqushiyan:languages=='zh'?'弯曲试验':'Bend test',
	wanqujiaodu:languages=='zh'?'弯曲角度':'Bend angle',
	wanquzhijing:languages=='zh'?'弯曲直径':'골곡 직경',
	yingdu:languages=='zh'?'硬度':'경도',
	beitu:languages=='zh'?'杯突':'ERICHSEN',
	bhzhi:languages=='zh'?'BH值':'BH값',
	ducengzhongliangliangmian:languages=='zh'?'镀层重量两面':'도금 중량 양면',
	ducengzhongliangshangmian:languages=='zh'?'镀层重量上面':'도금 중량 상면',
	ducengzhongliangxiamian:languages=='zh'?'镀层重量下面':'도금 중량 하면',
	rzhileixing:languages=='zh'?'R值类型':'R값유형',
	rzhi:languages=='zh'?'R值':'R값',
	nzhileixing:languages=='zh'?'N值类型':'N값유형',
	nzhi:languages=='zh'?'N值':'N값',
	gangjuanhao:languages=='zh'?'钢卷号':'코일번호',
	chongjifangxiang:languages=='zh'?'冲击方向':'충격 방향',
	shiyanghoudu:languages=='zh'?'试样厚度':'샘플두께',
	chongjiwendu:languages=='zh'?'冲击温度':'프레스온도',
	chongdiangong1:languages=='zh'?'冲击功1':'충격력1',
	chongdiangong2:languages=='zh'?'冲击功2':'충격력2',
	chongdiangong3:languages=='zh'?'冲击功3':'충격력3',
	zhiliangshujufenxi:languages=='zh'?'质量数据分析':'품질보증서 데이터 분석',
	xiugaimima:languages=='zh'?'修改密码':'비밀번호 변경',
	zhuxiao:languages=='zh'?'注销':'로그아웃',
	woyaochakucun:languages=='zh'?'我要查库存':'현재고 조회',
	woyaotihuo:languages=='zh'?'我要提货':'출하요청',
	woyaojiagong:languages=='zh'?'我要加工':'가공요청',
	yuanliaoguige:languages=='zh'?'原料规格':'자재 규격',
	shoutianjiagong:languages=='zh'?'手填加工':'수기 가공신청',
	daitijiaojiagongshenqing:languages=='zh'?'待提交加工申请':'가공신청제출대기',
	quanbutijiao:languages=='zh'?'全部提交':'모두 제출',
	yuanliaochengpinxuanze:languages=='zh'?'原料成品选择':'원소재제품 선택',
	qingxuanzeyuanliao:languages=='zh'?'请选择原料':'원소재 선택해주세요',
	chayuanliao:languages=='zh'?'查原料':'원소재 조회',
	weihujiagongchengpin:languages=='zh'?'维护加工成品':'제품 추가',
	tijiaoshenqing:languages=='zh'?'提交申请':'제출',
	dengfen:languages=='zh'?'等分':'등분',
	chengpinguigezhongliangshuliang:languages=='zh'?'成品规格重量数量':'제품규격중량수량',
	mobanmingcheng:languages=='zh'?'模板名称':'모반번호',
	shanchu:languages=='zh'?'删除':'취소',
	jiesuanfangshi:languages=='zh'?'结算方式':'결산방식',
	chengpinxinxi:languages=='zh'?'成品信息':'제품정보',
	lilunshuliang:languages=='zh'?'理论数量':'이론수량',
	lilunzongzhongliang:languages=='zh'?'理论总重量':'이론총중량',
	xiugaimima:languages=='zh'?'修改密码':'비밀번호 변경',
	yuanmima:languages=='zh'?'原密码':'현재비밀번호',
	xinmima:languages=='zh'?'新密码':'새비밀번호',
	querenmima:languages=='zh'?'确认密码':'새비밀번호확인',
	xinjiumimabuyiyang:languages=='zh'?'新密码与确认密码不一致':'새로운 비밀번호와 입력하신 비밀번호와 일치하지 않습니다.',
	mimaxiugaichenggong:languages=='zh'?'密码修改成功，请重新登录':'비밀번호가 정상적으로 변경되었습니다. 다시 로그인해주세요',
	yonghuming:languages=='zh'?'用户名':'ID',
	queding:languages=='zh'?'确定':'확인',
	bingbaohao:languages=='zh'?'并包号':'B번',
	tihuoriqi:languages=='zh'?'提货日期':'출하일자',
	jianshu:languages=='zh'?'件数':'수량',
	cangkuheji:languages=='zh'?'仓库合计':'창고합계',
	kunbaoshuliang:languages=='zh'?'捆包数量':'수량',
	qingkong:languages=='zh'?'清空':'내용 삭제',
	lailiaojiagong:languages=='zh'?'来料加工':'임가공',
	cangchu:languages=='zh'?'仓储':'보관',
	peisong:languages=='zh'?'配送':'배송',
	qita:languages=='zh'?'其他':'기타',
	chengpinkunbao:languages=='zh'?'成品捆包':'제품',
	shifoujixutijiao:languages=='zh'?'是否继续提交？':'계속하시겠습니까',
	bencitihuoshenqingyitijiaoshifoujixutihuo:languages=='zh'?'本次提货申请已提交，是否继续提货':'출하신청 제출 완료, 계속하시겠습니까？',
	jinrutihuoshenqingliebiao:languages=='zh'?'进入提货申请列表':'출하요청 리스트에 들어가기',
	fanhuitihuoshenqingliebiao:languages=='zh'?'返回提货申请列表':'출하요청 리스트에 돌아가기',
	gaikunbaomeiyoumobanbunengtianjiajihua:languages=='zh'?'该捆包没有模板，不能添加提货计划，请联系业务员!':'이 코일은 오더가 없어서 출하계획에 더할수 없습니다, 직원에게 문의하세요!',
	tihuoshenqingzhuliebiao:languages=='zh'?'提货申请主列表':'출하요청 리스트',
	jiazaishibai:languages=='zh'?'加载失败':'업데이트 실패',
	duxinceng:languages=='zh'?'镀锌层':'도금',
	mima:languages=='zh'?'密码':'비밀번호',
	yanzhengma:languages=='zh'?'验证码':'보안 문자',
	denglu:languages=='zh'?'登陆':'로그인',
	sousuochenggong:languages=='zh'?'搜索成功':'완료',
	qingxuanzejiaohuoqi:languages=='zh'?'请选择交货期':'납기일을 선택하세요',
	kunbaohaoweikongbunengchakan:languages=='zh'?'捆包号为空，无法查看质量数据':'코일번호가 입력되지 않아서 찾을 수 없습니다.',
	chexiaochenggong:languages=='zh'?'撤销成功':'취소완료',
	qingkonggouwuche:languages=='zh'?'清空购物车':'장바구니 비우기',
	qingtianxiejiagongzhongliang:languages=='zh'?'请填写加工重量':'가공중량을 입력해주세요',
	qingxuanzejiaohuoqi:languages=='zh'?'请选择交货期':'납기일을 선택하세요',
	qingtianjiagouwuche:languages=='zh'?'请添加购物车':'장바구니에 넣어주세요',
	caozuochenggong:languages=='zh'?'操作成功':'완료',
	shengyu:languages=='zh'?'剩余':'나머지',
	shengyudayu204shibixukouchu4mm:languages=='zh'?'剩余大于204时必须扣除4mm loss才能加工':'나머지가 204보다 클때 반드시 4mm의 loss를 뺴야 가공 할 수 있습니다.',
	biansi:languages=='zh'?'边丝':'loss',
	changduweikong:languages=='zh'?'长度为空':'길이를 입력해주세요',
	biansifanweibixuzai3dao40zhijianxiaoyu3zebuketijiao:languages=='zh'?'边丝范围必须在3-40之间，小于3则不可提交':'loss의 범위가 3-40사이어야합니다, 3보다 작으면 제출할 수 없습니다.',
	kouchu4mmlosscainengjiagong:languages=='zh'?'扣除4mm loss才能加工':'4mm의 loss를 빼야 가공 할 수 있습니다',
	biansibixuxiaoyu40:languages=='zh'?'边丝必须小于40':'로스는 반드시 40보다 작아야합니다.',
	biansibixudayudengyu3:languages=='zh'?'边丝必须大于等于3':'로스는 반드시 3과 같거나 커야합니다.',
	shengyubixudayudengyu3:languages=='zh'?'剩余必须大于等于3':'나머지는 반드시 3과 같거나 커야 합니다',
	qingzaibeizhuzhongtianxieshengyudebaozhuangfangshiheyujijihua:languages=='zh'?'请在备注中填写剩余的包装方式和预计计划！':'비고란에 나머지의 포장방식과 계획을 적어주세요',
	gaishengyuruowufakunbangjijangchuliweibiansi:languages=='zh'?'该剩余若无法捆绑将处理为边丝！':'나머지를 묶을 수 없다면 loss로 처리하게 됩니다!',
	gaishengyujiangchuliweibiansiwufakunbang:languages=='zh'?'该剩余将处理为边丝，无法捆绑！':'해당 나머지는 묶을 수 없어서 loss로 처리하게 됩니다.',
	biansudayudengyu40bixuweihuchengchengpinsizehuoshengyu:languages=='zh'?'边丝大于等于40，必须维护成成品size或剩余':'loss가 40보다 크거나 같으면 반드시 제품으로 입력하거나 나머지로 입력해야 합니다',
	yikouchu4mmloss:languages=='zh'?'已扣除4mmloss':'4mm loss를 뺐습니다.',
	biansizai3daosishizhijian:languages=='zh'?'边丝在3-40之间':'로스는 3-40사이입니다.',
	qingxuanze:languages=='zh'?'请选择':'선택해주세요',
	dangqianxuanzedejiesuanyonghuwei:languages=='zh'?'当前选择的结算用户为':'선택한 결산고객은',
	jiarugouwuchechenggong:languages=='zh'?'加入购物车成功':'장바구니 추가 완료',
	jiagongzhongliangdayuzhongliang:languages=='zh'?'加工重量大于重量':'가공중량이 원중량보다 큽니다',
	qingtianxiezhengquedejiagongzhongliang:languages=='zh'?'请填写正确的加工重量':'정확한 가공중량을 입력해주세요',
	kunbao:languages=='zh'?'捆包':'코일번호',
	weiweihuchengpinbunengtijiao:languages=='zh'?'未维护成品，不能提交！':'제품 미입력으로 제출할 수가 없습니다.',
	yuanliaoyicunzaiqingweihuchengpinxinxi:languages=='zh'?'原料已存在，请维护成品信息！':'원소재 선택완료, 제품정보를 입력해주세요!',
	jiaruweihuchengpinchenggong:languages=='zh'?'加入维护成品成功':'제품 추가 완료',
	gaikunbaomeiyoumiduwufatianjia:languages=='zh'?'该捆包没有密度，无法添加！':'해당 규격은 밀도 정보가 없어서 제출할 수가 없습니다.',
	gouwucheyiqingkong:languages=='zh'?'购物车已清空':'장바구니 비웠습니다',
	qingshuruyouxiang:languages=='zh'?'请输入您的邮箱':'이메일주소를 입력하세요',
	qingjianchayouxianggeshi:languages=='zh'?'请检查邮箱格式是否正确':'이메일주소 형식이 맞는지 확인해주세요',
	wangjimima:languages=='zh'?'忘记密码':'비밀번호를 잊었습니다',
	xiugaiyouxiang:languages=='zh'?'修改邮箱':'이메일주소 수정',
	qingshurudengluzhanghao:languages=='zh'?'请输入登录账号':'ID를 입력해주세요',
	xinmimayifasongzhiyouxiang:languages=='zh'?'新密码已发送至邮箱':'새로운 비밀번호를 e-mail로 전송하였습니다',
	qingdengluyouxiangchakan:languages=='zh'?'请登录邮箱查看':'이메일을 확인해주세요',
	changduweiCzhinengweiyi:languages=='zh'?'长度为C,只能为1':'슬리팅일 경우, 수량은 1만 가능합니다',
	lilunshuliangbunengbi:languages=='zh'?'理论数量不能比':'이론수량이',
	da:languages=='zh'?'大':'보다 클 수 없습니다',
	denglushibai:languages=='zh'?'登陆失败：':'실패:',
	biaozhunyi:languages=='zh'?'标准1':'표준1',
	biaozhuner:languages=='zh'?'标准2':'표준2',
	biaozhunsan:languages=='zh'?'标准3':'표준3',
	biaozhunsi:languages=='zh'?'标准4':'표준4',
	kehudingdanbianhao:languages=='zh'?'客户订单编号':'주문번호',
	dayinriqi:languages=='zh'?'打印日期':'출력일',
	Rzhileixing:languages=='zh'?'R值类型':'R값유형',
	Rzhi:languages=='zh'?'R值':'R값',
	Nzhi:languages=='zh'?'N值':'N값',
	Nzhileixing:languages=='zh'?'N值类型':'N값유형',
	BHzhi:languages=='zh'?'BH值':'BH값',
	duxincengliangmian:languages=='zh'?'镀锌层两面':'도금 양면',
	duxincengshangmian:languages=='zh'?'镀锌层上面':'도금 윗면',
	duxincengxiamian:languages=='zh'?'镀锌层下面':'도금 아랫면',
	shujujiazaiqingshaodeng:languages=='zh'?'数据加载中，请稍等':'진행중입니다. 잠시만 기다려주세요.',
	xinmimabunengweikong:languages=='zh'?'新密码不能为空':'새 비밀번호가 비어 있습니다',
	yikuchuku:languages=='zh'?'移库出库':'이동출고',
	xiaoshouchuku:languages=='zh'?'销售出库':'판매출고',
	jiagongchuku:languages=='zh'?'加工出库':'가공출고',
	cangchuchuku:languages=='zh'?'仓储出库':'보관출고',
	caigoutuihuochuku:languages=='zh'?'采购退货出库':'구매반품출고',
	zengsongchuku:languages=='zh'?'赠送出库':'증정출고',
	weiwaixiaoshouchuku:languages=='zh'?'委外销售出库':'외주판매출고',
	maoyiweiwaixiaoshouchuku:languages=='zh'?'贸易委外销售出库':'무역외주판매출고',
	yuanliaoweiwaichuku:languages=='zh'?'原料委外出库':'원소재외주출고',
	lailiaochuku:languages=='zh'?'来料出库':'임가공출고',
	yushouchuku:languages=='zh'?'预售出库':'선매출고',
	fenxuanchuku:languages=='zh'?'分选出库':'분할출고 ',
	huanhuochuku:languages=='zh'?'换货出库':'교환출고 ',
	baocun:languages=='zh'?'保存':'저장',
	
}

export default language;


// WEBPACK FOOTER //
// ./src/api/language.js